export const RADIO_INFO = [
  { subTitle: 'Real Estate, House, Vacant Lot, Building', title: 'Real Property', value: 'real' },
  { subTitle: 'Business Equipment', title: 'Personal Property', value: 'personal' },
  {
    subTitle: 'Farmland Assessment Act',
    title: 'Greenbelt',
    value: 'greenbelt',
  },
  {
    subTitle: 'Car / Truck',
    title: 'Motor Vehicle',
    value: 'vehicle',
  },
];
